/**
 * Ciudades visibles en registro/gestión de clientes (pasajeros).
 * Independiente de zonificación activa (eso aplica solo a conductores).
 */
export const CUSTOMER_CITIES = [
  { id: 'bogota', name: 'Bogotá', department: 'Cundinamarca' },
  { id: 'medellin', name: 'Medellín', department: 'Antioquia' },
  { id: 'cali', name: 'Cali', department: 'Valle del Cauca' },
  { id: 'barranquilla', name: 'Barranquilla', department: 'Atlántico' },
  { id: 'cartagena', name: 'Cartagena', department: 'Bolívar' },
  { id: 'bucaramanga', name: 'Bucaramanga', department: 'Santander' },
  { id: 'cucuta', name: 'Cúcuta', department: 'Norte de Santander' },
  { id: 'pereira', name: 'Pereira', department: 'Risaralda' },
  { id: 'manizales', name: 'Manizales', department: 'Caldas' },
  { id: 'armenia', name: 'Armenia', department: 'Quindío' },
  { id: 'santa_marta', name: 'Santa Marta', department: 'Magdalena' },
  { id: 'ibague', name: 'Ibagué', department: 'Tolima' },
  { id: 'villavicencio', name: 'Villavicencio', department: 'Meta' },
  { id: 'pasto', name: 'Pasto', department: 'Nariño' },
  { id: 'monteria', name: 'Montería', department: 'Córdoba' },
  { id: 'valledupar', name: 'Valledupar', department: 'Cesar' },
  { id: 'neiva', name: 'Neiva', department: 'Huila' },
  { id: 'popayan', name: 'Popayán', department: 'Cauca' },
  { id: 'sincelejo', name: 'Sincelejo', department: 'Sucre' },
  { id: 'tunja', name: 'Tunja', department: 'Boyacá' },
  { id: 'riohacha', name: 'Riohacha', department: 'La Guajira' },
  { id: 'florencia', name: 'Florencia', department: 'Caquetá' },
  { id: 'yopal', name: 'Yopal', department: 'Casanare' },
];

export const findCustomerCity = (cityId) =>
  CUSTOMER_CITIES.find((c) => c.id === cityId) || null;

export const isCustomerCityId = (cityId) => !!findCustomerCity(cityId);

export const customerCityLabel = (city) =>
  city?.department ? `${city.name} (${city.department})` : city?.name || '';

const normalizeCityName = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

/**
 * ¿La ciudad del perfil está operativa para conductores?
 * Usa ciudades de zonificación con active !== false (no la lista de clientes).
 */
export function isCityOperationalForDrivers(driverCities, profile = {}) {
  const active = (driverCities || []).filter((c) => c.active !== false);
  if (!active.length) return false;

  const cityId = profile.cityId || '';
  if (cityId && active.some((c) => c.id === cityId)) return true;

  const listed = findCustomerCity(cityId);
  const hint = normalizeCityName(profile.cityName || listed?.name || cityId);
  if (!hint) return false;

  return active.some((c) => {
    const cn = normalizeCityName(c.name);
    return cn && (cn === hint || cn.includes(hint) || hint.includes(cn));
  });
}
